import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ClientPortalShell } from './ClientPortalShell';
import { PortalUiProvider } from './PortalUi';
import { BoardPage } from './pages/BoardPage';
import { IntakeDevTools } from '../devtools/IntakeDevTools';

/**
 * OUW-62: el gate murió. `/status` y cualquier ruta vieja del portal caen en el
 * tablero conservando la query, así el link `/status?quoteID=…` sigue entrando
 * y el mock `?state=` / `?view=` sobrevive al redirect.
 */
function PortalRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/status/solicitud', search }} replace />;
}

export function ClientPortalRoutes() {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <PortalUiProvider>
        <ClientPortalShell>
          <Routes>
            <Route index element={<PortalRedirect />} />
            <Route path="solicitud" element={<BoardPage />} />
            {/* Cualquier /status/* que ya no exista (incluida la firma de oferta,
                que ahora es un modal del tablero) cae en la solicitud y
                conserva la query, así un link viejo no pierde el quoteID. */}
            <Route path="*" element={<PortalRedirect />} />
          </Routes>
          {/* Solo lectura acá: la solicitud ya se envió, no hay nada que cargar. */}
          <IntakeDevTools mode="portal" />
        </ClientPortalShell>
      </PortalUiProvider>
    </QueryClientProvider>
  );
}
